<template>
  <component :is="tag" class="container">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "div"
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.container {
  width: 100%;
  padding-right: variables.$padding-container;
  padding-left: variables.$padding-container;
  margin-right: auto;
  margin-left: auto;
  max-width: variables.$xl-width;
  &--main {
    padding-top: variables.$spacing-l;
    padding-bottom: variables.$spacing-l;
  }
}
</style>
